export enum Opacity {
  DRAGGING = 0.5,
  DEFAULT = 1,
}
